const Version = document.querySelector(`meta[name="tm-release"]`)?.content || "unset";

// Which language the page says it is in. The request below carries no cookies,
// so the server cannot read the session locale and answers in the default one:
// an English storefront page received the German bundle, and everything that
// takes its language from I18n.config afterwards - the cart client sends it as
// Accept-Language - then asked the API for German category and discount names.
// The locale rides in the URL, so the browser cache holds one entry per
// language instead of one entry that both languages share.
const Locale = document.documentElement.lang;

// Outside production the release stays the same while a locale file changes,
// so a cached module would hide every translation edit for an hour. The page
// says whether caching is allowed; anything but an explicit "off" keeps it.
const CachingAllowed = document.querySelector(`meta[name="tm-translation-cache"]`)?.content !== "off";

const JS_CACHE_NAME = "js-module-cache";
const ONE_HOUR = 60 * 60 * 1000;

async function importCachedJs(url) {
  if (!CachingAllowed) {
    const fresh = await fetch(url, { cache: "no-store", credentials: "omit" });
    if (!fresh.ok) throw new Error(`Failed to fetch JS: ${fresh.status}`);
    return importFromCode(await fresh.text());
  }

  const cache = await caches.open(JS_CACHE_NAME);

  const cacheKey = new Request(
    `${url}${url.includes("?") ? "&" : "?"}appversion=${encodeURIComponent(Version)}`
  );

  const cached = await cache.match(cacheKey);
  const now = Date.now();

  if (cached) {
    const cachedAt = Number(cached.headers.get("x-cached-at") || 0);

    if (now - cachedAt < ONE_HOUR) {
      console.log("[Translations] Loaded from cache");
      return importFromResponse(cached);
    }

    await cache.delete(cacheKey);
  }

  console.log("[Translations] Downloading translations");
  const fresh = await fetch(url, { cache: "no-store", credentials: "omit" });
  if (!fresh.ok) throw new Error(`Failed to fetch JS: ${fresh.status}`);

  const body = await fresh.text();

  await cache.put(
    cacheKey,
    new Response(body, {
      headers: {
        "content-type": "text/javascript",
        "x-cached-at": String(now),
      },
    })
  );

  return importFromCode(body);
}

async function importFromResponse(response) {
  return importFromCode(await response.text());
}

async function importFromCode(code) {
  const blob = new Blob([code], { type: "text/javascript" });
  const blobUrl = URL.createObjectURL(blob);

  try {
    return await import(/* webpackIgnore: true*/ blobUrl);
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}



try {
    const translations = new URL(`/current_translations`, window.location.href);
    if (Locale) translations.searchParams.set("locale", Locale);
    window.I18n = (await importCachedJs(translations.toString())).default;
} catch (e) {
    if (!!window["reportError"]) window.reportError(e);
    else                         console.error(e);
}

